import { h, render } from 'preact';
import { Provider } from 'react-redux';
import store from 'common/store/store';
import VideoRelatedArticles from './VideoRelatedArticles';

export default class VideoRelatedArticlesContainer {
    constructor( container ) {
        this.container = container.querySelector( '.js-container' );
        const data = {
            id: this.container.dataset.id,
            type: this.container.dataset.type,
            tag: this.container.dataset.tag,
            container
        }

        render( (
            <Provider store={store}>
                <VideoRelatedArticles data={data} />
            </Provider>
        ), this.container)
    }

    // Called when the widget is removed from the page
    destroy() {
        render( null, this.container );
    }
}